export default __webpack_public_path__ + "static/media/010-Colosseum.9a8af117.svg";